import { useSelector } from 'react-redux'
import { Redirect, Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import { Layout } from 'src/components/Layout'
import { isLoading } from 'src/redux/slices/project/selectors'
import { selectAuthorized } from 'src/redux/slices/user/selectors'
import { TabsConfig, WorkflowTopLevelProps } from 'src/types/general'

import ProjectPage from './pages/ProjectPage'
import SurveyPage from './pages/SurveyPage'
import TasksPage from './pages/TasksPage'

///// Component
const ProjectDashboard: React.FC<React.PropsWithChildren<WorkflowTopLevelProps>> = ({
  children,
  tabValue,
}) => {
  const loading = useSelector(isLoading)
  const authorized = useSelector(selectAuthorized)
  // const error = useSelector(state => state.analysis.error)
  // const hasData = useSelector(state => state.analysis.data !== null)
  // const allSettingsConfirmed = useSelector(selectAllSettingsConfirmed)
  const { path } = useRouteMatch()

  const tabsConfig: TabsConfig = {
    tabs: {
      tasks: {
        title: 'Tasks',
        description: 'Walkthrough the various steps necessary to build your UBEM.',
        label: 'Tasks',
        disabled: false,
        hidden: !authorized,
        component: <TasksPage />,
      },
      info: {
        title: 'Project Information',
        description: 'Enter project configuration information and metadata',
        label: 'Info',
        disabled: false,
        hidden: !authorized,
        component: <SurveyPage />,
        hideHeader: false,
      },
      dashboard: {
        title: 'Dashboard',
        description: 'Overview and management for a project.',
        label: 'Dashboard',
        disabled: false,
        hidden: !authorized,
        component: <ProjectPage />,
        hideHeader: true,
      },
    },
    defaultTab: 'tasks',
    root: {
      title: 'Project',
      description: 'Project overview',
      component: <div>More info coming</div>,
      redirect: true,
    },
    otherRoutes: {
      someOtherRoute: {
        component: <div>hello there</div>,
      },
    },
    // root: "analysis",
  }
  return (
    <Layout tabsConfig={tabsConfig} loading={loading}>
      {children}
    </Layout>
  )
}

export default ProjectDashboard
